<template>
  <div>
    <div class="aditional-container round-container p-2">
      <ValidationObserver ref="formObserver" tag="form" novalidate>
        <div class="bg-white">
          <icon-view
            :has-border="false"
            class="ml-3 pt-4 pb-4"
            icon="fas fa-info-circle color-orange"
            icon-size="1rem"
            :title="
              this.item.rejectPanel
                ? 'Detalles de la Denegación:'
                : 'Comentario'
            "
            variant="custom-icon-view"
          />
          <div class="col-md-12 ml-1 mb-2">
            <div v-if="showDropDowns" class="row mx-4 mr-1">
              <div class="col-12 col-md-12 col-lg-12 py-1">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="selectedDenegationStatus"
                    :error="errors[0]"
                    custom-error-msg="Seleccione una Razón"
                    fieldname="name"
                    fieldkey="id"
                    :options="denegationStatuses"
                    placeholder="Seleccione una Razón"
                    rules="required"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div
              v-if="showCommentsSectoin || showReasonDropDownComment"
              class="row mx-4 mr-1"
            >
              <div class="col-12 col-md-12 col-lg-12 py-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="
                    `${
                      showCommentsSectoin || showReasonDropDownComment
                        ? 'required'
                        : ''
                    }`
                  "
                >
                  <CustomTextArea
                    v-model="comments"
                    :maxlength="3000"
                    :rows="5"
                    :show-char-count="true"
                    :single-line="true"
                    :error="errors[0]"
                    :custom-error-msg="getCustomErrorMsg"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 py-1 pl-0 mt-2 text-right">
            <div class="mt-2">
              <ActionButton
                i="fas fa-times-circle"
                variant="outline-danger"
                class="px-3 mt-1 mr-2"
                text="Cancelar"
                @click="cancel"
              />
              <ActionButton
                variant="success"
                class="px-4 mt-1"
                text="Guardar"
                @click="save"
              />
            </div>
          </div>
          <br />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
const reasonWithDetails = Object.freeze({
  Incongruity: 6,
  IncompleteInformation: 8,
  IncompleteCertification: 11,
});

import { CustomTextArea, ActionButton } from '@/components/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import IconView from 'icon-view';
export default {
  name: 'RLVEvidenceActionContent',
  components: {
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    CustomTextArea,
    CustomDropDown,
    IconView,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      id: 0,
      comments: '',
      selectedDenegationStatus: null,
      denegationStatuses: [],
    };
  },
  watch: {},
  computed: {
    getCustomErrorMsg() {
      let msg = this.item.rejectPanel
        ? 'Favor de entrar el comentario de la denegación'
        : 'Favor de entrar el comentario';
      return msg;
    },
    showDropDowns() {
      return this.item.rejectPanel;
    },
    showReasonDropDownComment() {
      const validOptionsToShowComment = [
        reasonWithDetails.Incongruity,
        reasonWithDetails.IncompleteInformation,
        reasonWithDetails.IncompleteCertification,
      ];
      return (
        validOptionsToShowComment.includes(this.selectedDenegationStatus?.id) ||
        this.$store.getters.HasPermission('rlv.denial.comment')
      );
    },
    showCommentsSectoin() {
      if (!this.item.rejectPanel) return true;
      return false;
    },
  },
  methods: {
    async save() {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) return;
      if (this.item.rejectPanel) {
        this.$emit('rejectEvidence', {
          comments: this.comments,
          denegationReasonId: this.selectedDenegationStatus.id,
        });
      } else {
        this.$emit('revertItem', this.comments);
      }
    },
    async cancel() {
      this.$emit('cancelEvidence', this.item);
    },
    async LoadValidationMessages() {
      const messageCodes = ['R90019', 'R90018'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    async LoadDenegationReasons() {
      this.$ApiGet('/api/rlvEvidence/getdenegationreasons').then((res) => {
        this.denegationStatuses = res.data;
      });
    },
    GetMessage(code) {
      const message = this.validationMessages
        ? this.validationMessages.find((element) => element.id == code)
        : '';

      return message;
    },
  },
  async mounted() {
    this.LoadValidationMessages();
    this.LoadDenegationReasons();
  },
};
</script>

<style scoped>
.board {
  flex-grow: 3;
}

.bag {
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 10px 30px;
}

textarea#evidenceComment {
  min-height: 2.375rem !important;
}

@media screen and (max-width: 850px) {
  .flex {
    flex-wrap: wrap;
  }
  .dd {
    margin-bottom: 5%;
  }
}

.aditional-container {
  background-color: #f7f7f7;
}
.round-container {
  border-radius: 5px;
}
</style>
